import { customRequest } from "@/utils/custom-fetch";

const EARNING_OPTIONS_URL = '/api/v1/pools/sub_account/references/earning_options/';

export const getEarningOptions = () => customRequest.getItem(EARNING_OPTIONS_URL);
